import {Component, inject, OnInit} from '@angular/core';
import {CommonModule, Location} from '@angular/common';
import {ActivatedRoute} from "@angular/router";
import {
    DxButtonModule,
    DxLoadPanelModule,
    DxToolbarModule,
    DxScrollViewModule,
    DxTabsModule,
    DxDataGridModule
} from "devextreme-angular";
import {
    InventoryClient,
    StorageUnitDto,
    GenericMaterialType,
    StorageUnitStatus
} from '@services';
import notify from "devextreme/ui/notify";
import EnumUtils from "../../../../shared/enum-utils";
import {CapitalCasePipe} from "../../../../pipes/capital-case.pipe";
import {StorageUnitMaterialComponent} from "./storage-unit-material/storage-unit-material.component";
import {StorageUnitHistoryComponent} from "./storage-unit-history/storage-unit-history.component";
import {PalletTypePipe} from "../../../../pipes/pallet-type.pipe";

@Component({
    selector: 'app-storage-unit-details',
    standalone: true,
    imports: [
        CommonModule,
        DxToolbarModule,
        DxButtonModule,
        DxLoadPanelModule,
        DxScrollViewModule,
        DxTabsModule,
        DxDataGridModule,
        CapitalCasePipe,
        StorageUnitMaterialComponent,
        StorageUnitHistoryComponent,
        PalletTypePipe
    ],
    templateUrl: './storage-unit-details.component.html',
    styles: [
        `.view-wrapper-scroll {
            height: calc(100vh - 200px);
        }`
    ],
})
export class StorageUnitDetailsComponent implements OnInit {
    private route = inject(ActivatedRoute);
    private location = inject(Location);
    private inventoryClient = inject(InventoryClient);

    protected unitNumber: string | null = null;
    protected storageUnit: StorageUnitDto = new StorageUnitDto();
    protected isLoading = false;
    protected GenericMaterialType = GenericMaterialType;

    protected tabs = [
        {id: 0, text: 'General Information'},
        {id: 1, text: 'Bin History'}
    ];
    protected selectedTabId = 0;

    protected getStatusBadgeClass(status?: StorageUnitStatus): string {
        return status ? EnumUtils.getStorageUnitStatusBadgeClass(status) : '';
    }

    ngOnInit(): void {
        this.unitNumber = this.route.snapshot.paramMap.get('number');
        if (this.unitNumber) {
            this.loadStorageUnit();
        } else {
            notify('Storage Unit Number missing', 'error', 3000);
        }
    }

    private loadStorageUnit() {
        this.isLoading = true;
        this.inventoryClient.getStorageUnit(this.unitNumber!).subscribe({
            next: (data) => {
                this.storageUnit = data;
                this.isLoading = false;
            },
            error: () => {
                notify('Failed to load storage unit', 'error', 3000);
                this.isLoading = false;
                this.location.back();
            }
        });
    }

    onTabClick(e: any) {
        this.selectedTabId = e.itemData.id;
    }
}
